import React, { ComponentType, FC, ReactNode } from 'react';
import { compose, Dispatch } from 'redux';
import { connect, ConnectedProps } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { hasCurrentUserErrors } from '../../ducks/user.duck';
import { authenticationInProgress } from '../../ducks/Auth.duck';
import { manageDisableScrolling } from '../../ducks/UI.duck';
import { Topbar } from '../../components';

interface TopbarContainerComponentProps {
  mainNavbarSectionClassName?: string;
  topbarDesktopClassName?: string;
  topbarMobileClassName?: string;
  topbarMobileRootClassName?: string;
  currentPage?: string;
  currentSearchParams?: Record<string, any>;
  additionalMainNavbarSectionChildren?: ReactNode;
}

type PropsFromRedux = ConnectedProps<typeof connector>;
type TopbarContainerProps = PropsFromRedux & RouteComponentProps & TopbarContainerComponentProps;

export const TopbarContainerComponent: FC<TopbarContainerProps> = ({
  authInProgress,
  currentPage,
  currentSearchParams,
  currentUser,
  history,
  isAuthenticated,
  hasGenericError,
  location,
  onManageDisableScrolling,
  mainNavbarSectionClassName,
  topbarDesktopClassName,
  topbarMobileClassName,
  topbarMobileRootClassName,
  additionalMainNavbarSectionChildren,
}) => (
  <Topbar
    authInProgress={authInProgress}
    mainNavbarSectionClassName={mainNavbarSectionClassName}
    topbarDesktopClassName={topbarDesktopClassName}
    topbarMobileClassName={topbarMobileClassName}
    topbarMobileRootClassName={topbarMobileRootClassName}
    currentPage={currentPage}
    currentSearchParams={currentSearchParams}
    currentUser={currentUser}
    history={history}
    isAuthenticated={isAuthenticated}
    location={location}
    onManageDisableScrolling={onManageDisableScrolling}
    showGenericError={hasGenericError}
    additionalMainNavbarSectionChildren={additionalMainNavbarSectionChildren}
  />
);

const mapStateToProps = (state: any) => {
  const { isAuthenticated, logoutError } = state.Auth;
  const { currentUser } = state.user;
  const hasGenericError = !!(logoutError || hasCurrentUserErrors(state));

  return {
    authInProgress: authenticationInProgress(state),
    currentUser,
    isAuthenticated,
    hasGenericError,
  };
};

const mapDispatchToProps = (dispatch: Dispatch) => ({
  onManageDisableScrolling: (componentId: string, disableScrolling: boolean) =>
    dispatch(manageDisableScrolling(componentId, disableScrolling)),
});

const connector = connect(mapStateToProps, mapDispatchToProps);

// Note: it is important that the withRouter HOC is **outside** the
// connect HOC, otherwise React Router won't rerender any Route
// components since connect implements a shouldComponentUpdate
// lifecycle hook.
//
// See: https://github.com/ReactTraining/react-router/issues/4671
const TopbarContainer = compose(
  withRouter,
  connector
)(TopbarContainerComponent) as ComponentType<TopbarContainerComponentProps>;

export default TopbarContainer;
